import React, { useState } from 'react'
import footerlogo from "../../Assets/images/footer-logo.svg"
import { Link } from 'react-router-dom'
import { LanguageConstants } from '../../constants/LanguageConstants'
import { useSelector } from 'react-redux'
import ContactusModal from '../../Modal/ContactusModal'
import { Modal } from 'react-bootstrap'


function Footer() {
    const [contacShow , setContactShow] = useState(false)
  const profiledata = useSelector((state:any)=>state?.ProfileState)
  const handelContactUsClose =()=>{
    setContactShow(false)
   }
  return (
   <>
   <footer className="main-footer">
  <div className="foot-top">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <a href="#" className="footer-logo">
            <img src={footerlogo}  />
          </a>
          <ul className="foot-menus">
            <li className="foot-menus-single"><Link to={'/product'}>{LanguageConstants?.PRODUCTLISTING}</Link></li>
            <li className="foot-menus-single"><Link to={'/faq'}>{LanguageConstants?.FAQS}</Link></li>
            <li className="foot-menus-single"><Link to={'/cms/about-us'}>{LanguageConstants?.ABOUTUS}</Link></li>
            {profiledata?.data?.data ? <>
            <li className="foot-menus-single" onClick={()=>setContactShow(true)} style={{cursor:'pointer'}}><a className="nav-link" > {LanguageConstants?.CONTACTUS}</a></li>
            {/* <li className="foot-menus-single"><Link to={'/create-request-quote'}>{LanguageConstants?.REQUESTQUOTES}<i  /></Link></li> */}
            </>
          :null}
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div className="footer-bottom">
    <div className="container">
      <div className="row gy-2">
        <div className="col-md-6 text-center text-md-start">
        {LanguageConstants?.COPYRIGHT}
        </div>
        <div className="col-md-6">
          <div className="foot-cms-link text-center text-md-end">
            <Link className='privacy-policy-link' to={'/cms/privacy-policy'} >{LanguageConstants?.PRIACYPOLICY}</Link>
            <span className="sepr-pipe">|</span>
            <Link  className='privacy-policy-link' to={'/cms/terms-and-conditions'}>{LanguageConstants?.TERMS  }</Link>
          </div>
        </div>
      </div>
    </div>
  </div>
   </footer>
    {/* Contact us modal */}
 <Modal show={contacShow} >
   <ContactusModal handelClso ={handelContactUsClose} />
  </Modal>
 {/* Contact us modal */}
   </>
  )
}

export default Footer